<app-theme-toggle class="reset-password__theme-toggle" />

<div class="reset-password project-backdrop" data-backdrop="vagues">
  <a routerLink="/sign-in" class="reset-password__brand" aria-label="Mokah+, retour à la connexion">mokah<span>+</span></a>

  <div class="reset-password__card">
    <!-- Koffi : une pose par étape (catalogue MOKKIE_POSES) -->
    @switch (view()) {
      @case ('request') { <img class="reset-password__mascot" [src]="mascots.reflexion" alt="" width="112" height="112" aria-hidden="true" /> }
      @case ('success-request') { <img class="reset-password__mascot" [src]="mascots.lecture" alt="" width="112" height="112" aria-hidden="true" /> }
      @case ('recovery') { <img class="reset-password__mascot" [src]="mascots.guide" alt="" width="112" height="112" aria-hidden="true" /> }
      @case ('success-recovery') { <img class="reset-password__mascot" [src]="mascots.bravo" alt="" width="112" height="112" aria-hidden="true" /> }
    }

    @if (view() === 'request') {
      <!-- ── Vue : demande de reset ── -->
      <div class="reset-password__header">
        <p class="reset-password__eyebrow">Mot de passe oublié</p>
        <h1 class="reset-password__title">Pas de panique, <span class="reset-password__accent">ça arrive</span></h1>
        <p class="reset-password__subtitle">
          Saisissez l'adresse email de votre compte : nous vous envoyons un lien pour choisir un nouveau mot de passe.
        </p>
      </div>

      <form [formGroup]="requestForm" class="reset-password__form" (ngSubmit)="requestReset()">
        <div class="form-group">
          <label for="rp-email" class="form-label">Adresse email</label>
          <div class="input-wrapper">
            <ng-icon name="iconoirMail" class="input-icon" size="18"></ng-icon>
            <input
              id="rp-email"
              type="email"
              autocomplete="email"
              formControlName="email"
              class="form-input"
              placeholder="vous@entreprise.com"
              [attr.aria-invalid]="requestForm.controls.email.touched && requestForm.controls.email.invalid"
            >
          </div>
          @if (requestForm.controls.email.touched) {
            @if (requestForm.controls.email.hasError('required')) {
              <span class="error-message">Saisissez l'adresse email de votre compte.</span>
            } @else if (requestForm.controls.email.hasError('email')) {
              <span class="error-message">Cette adresse email n'est pas valide. Exemple : vous&#64;entreprise.com</span>
            }
          }
        </div>

        @if (errorMessage()) {
          <p class="error-banner" role="alert">
            <ng-icon name="iconoirWarningCircle" size="18"></ng-icon>
            <span>{{ errorMessage() }}</span>
          </p>
        }

        <div class="reset-password__actions">
          <app-btn
            class="reset-password__submit"
            [config]="{
              type: 'filled',
              color: 'coffee',
              icon: 'iconoirArrowRight',
              disabled: pending()
            }"
            (click)="requestReset()"
          >
            {{ pending() ? 'Envoi en cours…' : 'Envoyer le lien de réinitialisation' }}
          </app-btn>
        </div>
      </form>

      <div class="reset-password__back">
        <a routerLink="/sign-in" class="back-link">Retour à la connexion</a>
      </div>
    }

    @if (view() === 'success-request') {
      <!-- ── Vue : lien envoyé ── -->
      <div class="reset-password__success">
        <div class="success-icon">
          <ng-icon name="iconoirCheckCircle" size="28"></ng-icon>
        </div>
        <h2 class="reset-password__title">Vérifiez votre boîte mail</h2>
        <p class="reset-password__subtitle">
          Un lien de réinitialisation a été envoyé à <strong>{{ requestForm.getRawValue().email }}</strong>.
          Cliquez dessus pour choisir un nouveau mot de passe.
        </p>
        <p class="reset-password__spam">Rien reçu d'ici quelques minutes ? Pensez à vérifier vos spams.</p>
        <div class="reset-password__back">
          <a routerLink="/sign-in" class="back-link">Retour à la connexion</a>
        </div>
      </div>
    }

    @if (view() === 'recovery') {
      <!-- ── Vue : saisie du nouveau mot de passe ── -->
      <div class="reset-password__header">
        <p class="reset-password__eyebrow">Nouveau mot de passe</p>
        <h1 class="reset-password__title">Choisissez un <span class="reset-password__accent">nouveau</span> mot de passe</h1>
        <p class="reset-password__subtitle">Il remplacera l'ancien dès que vous l'aurez enregistré.</p>
      </div>

      <form [formGroup]="recoveryForm" class="reset-password__form" (ngSubmit)="updatePassword()">
        <div class="form-group">
          <label for="rp-new" class="form-label">Nouveau mot de passe</label>
          <div class="input-wrapper">
            <ng-icon name="iconoirLock" class="input-icon" size="18"></ng-icon>
            <input
              id="rp-new"
              type="password"
              autocomplete="new-password"
              formControlName="newPassword"
              class="form-input"
              placeholder="Minimum 8 caractères"
              (focus)="showPasswordRules.set(true)"
              (blur)="showPasswordRules.set(false)"
            >
          </div>
          @if (showPasswordRules() || (recoveryForm.controls.newPassword.touched && recoveryForm.controls.newPassword.invalid)) {
            <ul class="password-rules">
              <li [class.ok]="(recoveryForm.controls.newPassword.value?.length ?? 0) >= 8">8 caractères minimum</li>
              <li [class.ok]="!!recoveryForm.controls.newPassword.value?.match('[A-Z]')">Une majuscule</li>
              <li [class.ok]="!!recoveryForm.controls.newPassword.value?.match('[a-z]')">Une minuscule</li>
              <li [class.ok]="!!recoveryForm.controls.newPassword.value?.match('[0-9]')">Un chiffre</li>
              <li [class.ok]="!!recoveryForm.controls.newPassword.value?.match('[^A-Za-z0-9]')">Un caractère spécial (- _ . ! @ # …)</li>
            </ul>
          }
        </div>

        <div class="form-group">
          <label for="rp-confirm" class="form-label">Confirmer le mot de passe</label>
          <div class="input-wrapper">
            <ng-icon name="iconoirLock" class="input-icon" size="18"></ng-icon>
            <input
              id="rp-confirm"
              type="password"
              autocomplete="new-password"
              formControlName="confirmPassword"
              class="form-input"
              placeholder="Répétez le mot de passe"
            >
          </div>
          @if (recoveryForm.controls.confirmPassword.touched && recoveryForm.hasError('passwordsMismatch')) {
            <span class="error-message">Les deux mots de passe sont différents. Saisissez à nouveau le même.</span>
          }
        </div>

        @if (errorMessage()) {
          <p class="error-banner" role="alert">
            <ng-icon name="iconoirWarningCircle" size="18"></ng-icon>
            <span>{{ errorMessage() }}</span>
          </p>
        }

        <div class="reset-password__actions">
          <app-btn
            class="reset-password__submit"
            [config]="{
              type: 'filled',
              color: 'coffee',
              icon: 'iconoirArrowRight',
              disabled: pending()
            }"
            (click)="updatePassword()"
          >
            {{ pending() ? 'Mise à jour…' : 'Mettre à jour le mot de passe' }}
          </app-btn>
        </div>
      </form>
    }

    @if (view() === 'success-recovery') {
      <!-- ── Vue : succès du changement ── -->
      <div class="reset-password__success">
        <div class="success-icon success-icon--green">
          <ng-icon name="iconoirCheckCircle" size="28"></ng-icon>
        </div>
        <h2 class="reset-password__title">Mot de passe mis à jour</h2>
        <p class="reset-password__subtitle">
          Votre nouveau mot de passe est enregistré. Nous vous ouvrons votre espace…
        </p>
      </div>
    }

  </div>
</div>
